"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinutesInMilliseconds = void 0;
const getMinutesInMilliseconds = (minutes) => {
    return minutes * 60 * 1000;
};
exports.getMinutesInMilliseconds = getMinutesInMilliseconds;
